import { c as _c } from "react/compiler-runtime";
import { Heading, TextLink, TextPassage } from '@petsmart-ui/sparky';
import type { ComponentType, MouseEvent, SVGProps } from 'react';
import { getBaseUrlJoined, trackNavigationHeaderClick } from '@libs/analytics';
import type { CurrentTierLevel } from '@libs/common-types';
import { handleAccountClick } from '@libs/experience-api';
import TreatsRewardsIcon from '../../../shared/treats-rewards.icon.svg';
import { useAccountAuthenticated } from '../../use-account-authenticated';
import { BestieIcon, MemberIcon, VippIcon } from './icons';
import './details.scss';
const TREATS_REWARDS_HREF = '/treats-rewards/authenticated';
type TierIcon = ComponentType<SVGProps<SVGSVGElement>>;
const TIERS: Record<CurrentTierLevel, {
  tierLabel: string;
  TierIcon: TierIcon;
}> = {
  member: {
    tierLabel: 'Member',
    TierIcon: MemberIcon
  },
  bestie: {
    tierLabel: 'Bestie',
    TierIcon: BestieIcon
  },
  vipp: {
    tierLabel: 'VIPP',
    TierIcon: VippIcon
  }
};
type DetailsProps = {
  onAction: () => void;
};
type TreatsRewardsClickInput = {
  event: MouseEvent<Element>;
  selection: string;
};
export function Details(t0) {
  const $ = _c(21);
  const {
    onAction
  } = t0;
  const {
    firstName,
    loyaltyData
  } = useAccountAuthenticated();
  const tierData = loyaltyData ? TIERS[loyaltyData.currentTierLevel] : null;
  let t1;
  if ($[0] !== onAction) {
    t1 = async function handleTreatsRewardsClick(t2) {
      const {
        event,
        selection
      } = t2;
      trackNavigationHeaderClick(selection, getBaseUrlJoined(TREATS_REWARDS_HREF) ?? TREATS_REWARDS_HREF);
      onAction();
      await handleAccountClick({
        event: event as MouseEvent<HTMLAnchorElement>,
        href: TREATS_REWARDS_HREF
      });
    };
    $[0] = onAction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleTreatsRewardsClick = t1;
  let t2;
  if ($[2] !== firstName) {
    t2 = <Heading className="account-authenticated-details__greeting" tagName="h2" size="body-lg-bold">Hi, <span className="account-authenticated-details__capitalize">{firstName}</span>!</Heading>;
    $[2] = firstName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== loyaltyData || $[5] !== tierData) {
    t3 = loyaltyData && tierData && <><p className="account-authenticated-details__tier">{tierData.tierLabel}<tierData.TierIcon aria-hidden="true" className="account-authenticated-details__tier-icon" /></p><div className="account-authenticated-details__balance"><Heading tagName="h3" size="body-bold">${loyaltyData.availableDollars} Treats balance</Heading><TextPassage className="account-authenticated-details__points">({loyaltyData.availablePoints} points)</TextPassage></div></>;
    $[4] = loyaltyData;
    $[5] = tierData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleTreatsRewardsClick) {
    t4 = async event_0 => {
      await handleTreatsRewardsClick({
        event: event_0,
        selection: "treatsrewards"
      });
    };
    $[7] = handleTreatsRewardsClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TreatsRewardsIcon aria-label="Treats Rewards" className="account-authenticated-details__treats-logo" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <a href={TREATS_REWARDS_HREF} aria-label="Treats Rewards" onClick={t4}>{t5}</a>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== handleTreatsRewardsClick) {
    t7 = <TextLink className="account-authenticated-details__see-benefits" href={TREATS_REWARDS_HREF} onClick={async event_1 => {
      await handleTreatsRewardsClick({
        event: event_1,
        selection: "see benefits"
      });
    }}>See benefits</TextLink>;
    $[12] = handleTreatsRewardsClick;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="account-authenticated-details__treats">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t8) {
    t9 = <div className="account-authenticated-details">{t2}{t3}{t8}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}